import React, { useEffect, useMemo, useState } from 'react';
import GridProvider from './components/GridProvider';
import useHttp from '../../../../hooks/use-http';
import styles from './Izvestaji.module.css';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';

// porukaPrazno: ako je prosleđena, umesto prazne tabele prikazuje se ta poruka
const Izvestaji = ({
  idNaloga,
  objekat = 'IzvestajRNPURPDF',
  porukaPrazno,
  evidencijaSlanja = false,
}) => {
  const {
    sendRequest: getGridData,
    data: gridData,
    isLoading: isLoadingGrid,
  } = useHttp('');
  const [zapocetoUcitavanje, setZapocetoUcitavanje] = useState(false);
  useEffect(() => {
    if (isLoadingGrid) setZapocetoUcitavanje(true);
  }, [isLoadingGrid]);
  const prikaziPorukuPrazno =
    !!porukaPrazno &&
    zapocetoUcitavanje &&
    !isLoadingGrid &&
    (!Array.isArray(gridData) || gridData.length === 0);
  const [openPath, setOpenPath] = useState(null);
  const [openDocument, setOpenDocument] = useState(false);
  const { getData } = useHttp('');

  const vratiGrid = () => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/vrati_dokumenta_objekta',
      data: {
        idObjekta: idNaloga,
        objekat,
      },
    };
    getGridData(config);
  };
  const [evidencija, setEvidencija] = useState([]);
  const vratiEvidenciju = async () => {
    const response = await getData({
      method: 'POST',
      url: 'DokRNServisni/DokRNServisniEmailEvidencija_Vrati',
      data: { idDok: idNaloga },
    });
    setEvidencija(Array.isArray(response) ? response : []);
  };
  useEffect(() => {
    vratiGrid();
    if (evidencijaSlanja) vratiEvidenciju();
  }, []);
  // adrese iz evidencije slanja, po fajlu (id = DokumentaURL.Id = idDokumentaURL)
  const redovi = useMemo(() => {
    if (!evidencijaSlanja || !Array.isArray(gridData)) return gridData;
    return gridData.map((red) => {
      const adrese = evidencija.filter((e) => e.idDokumentaURL === red.id);
      return {
        ...red,
        poslatoNa: adrese.filter((e) => e.poslato).map((e) => e.email),
        nijePoslatoNa: adrese.filter((e) => !e.poslato).map((e) => e.email),
      };
    });
  }, [gridData, evidencija, evidencijaSlanja]);
  const handleOpenFile = (item) => {
    setOpenPath(item.path);
    setOpenDocument(true);
  };
  const downloadFile = async (fileUrl, fileName) => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/konvertovanje_base64',
      data: { vrednost: fileUrl },
    };

    const response = await getData(config);

    const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };
  return (
    <div>
      {' '}
      {prikaziPorukuPrazno ? (
        <div className={styles.prazno}>
          <i className="fas fa-file-pdf" />
          <span>{porukaPrazno}</span>
        </div>
      ) : (
        <GridProvider
          data={redovi}
          loading={isLoadingGrid}
          handleOpenFile={handleOpenFile}
          downloadFile={downloadFile}
          evidencijaSlanja={evidencijaSlanja}
        />
      )}{' '}
      <MuiDialog
        maxWidth="md"
        open={openDocument}
        title="DOCUMENT"
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Izvestaji;
